<template>
  <div class="filter-control">
    <!-- Select Filter -->
    <v-select
      v-if="filter.type === 'select'"
      :model-value="value"
      :items="filter.options"
      :label="filter.label"
      :placeholder="filter.placeholder"
      variant="outlined"
      density="compact"
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-select>

    <!-- Multi-Select Filter -->
    <v-select
      v-else-if="filter.type === 'multiselect'"
      :model-value="value"
      :items="filter.options"
      :label="filter.label"
      :placeholder="filter.placeholder"
      variant="outlined"
      density="compact"
      multiple
      chips
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-select>

    <!-- Text Filter -->
    <v-text-field
      v-else-if="filter.type === 'text'"
      :model-value="value"
      :label="filter.label"
      :placeholder="filter.placeholder"
      variant="outlined"
      density="compact"
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-text-field>

    <!-- Number Filter -->
    <v-text-field
      v-else-if="filter.type === 'number'"
      :model-value="value"
      :label="filter.label"
      :placeholder="filter.placeholder"
      type="number"
      variant="outlined"
      density="compact"
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-text-field>

    <!-- Date Filter -->
    <v-text-field
      v-else-if="filter.type === 'date'"
      :model-value="value"
      :label="filter.label"
      type="date"
      variant="outlined"
      density="compact"
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-text-field>

    <!-- Boolean Filter -->
    <v-switch
      v-else-if="filter.type === 'boolean'"
      :model-value="value"
      :label="filter.label"
      color="primary"
      density="compact"
      @update:model-value="updateValue"
    />

    <!-- Fallback -->
    <v-text-field
      v-else
      :model-value="value"
      :label="filter.label"
      :placeholder="filter.placeholder"
      variant="outlined"
      density="compact"
      clearable
      @update:model-value="updateValue"
    >
      <template #prepend-inner>
        <v-icon v-if="filter.icon">{{ filter.icon }}</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script setup lang="ts">
import type { FilterConfig, FilterValue } from '@/types/analytics'

// 📝 Props & Emits
interface Props {
  filter: FilterConfig
  value: FilterValue
}

const props = defineProps<Props>()

const emit = defineEmits<{
  update: [filterId: string, value: FilterValue]
}>()

// 🔄 Methods
const updateValue = (newValue: FilterValue) => {
  emit('update', props.filter.id, newValue)
}
</script>

<style scoped>
.filter-control {
  width: 100%;
}
</style>
